import React from 'react';
import './App.css';
import { Header } from '../header/Header';
import WeatherList from '../weather/WeatherList';
import Settings from '../settings/Settings';
import Pomodoro from '../pomodoro/Pomodoro';
import News from '../news/News'
import CurrentDate from '../dateAndTime/CurrentDate';



class App extends React.Component {
constructor() {
	super()
	this.state = {
		weather: false,
		settings: false,
		todo: false,
		news: false,
		pomo: false,
	}

	this.clickToPin = this.clickToPin.bind(this)
	this.slideBackgroundToZero = this.slideBackgroundToZero.bind(this)
	this.slideBackgroundToNegative = this.slideBackgroundToNegative.bind(this)
	this.openSettings = this.openSettings.bind(this)
	this.closeSettings = this.closeSettings.bind(this)
}
	


	toggleWeather() {
		if (this.state.weather === false) {
			this.setState({weather: true})
			document.querySelector('.weather-container').style.display = 'block';
			setTimeout(()=>{
				document.querySelector(".weather-container").classList.add('show');
			}, 10)
		} else {
			this.setState({weather: false})
			document.querySelector(".weather-container").classList.remove('show');
			setTimeout(()=>{
				document.querySelector('.weather-container').style.display = 'none';
			}, 500)
		}
	}

	clickToPin(e) {
			let target = e.currentTarget.id;
			if (this.state[target] === false) {
				this.setState({[target]: true})
				document.querySelector(`.${target}-container`).classList.add('show')
				document.querySelector(`#${target}-pin`).classList.add('show')	
			} else {
				this.setState({[target]: false})
				document.querySelector(`.${target}-container`).classList.remove('show')
				document.querySelector(`#${target}-pin`).classList.remove('show')	
			}
		e.stopPropagation()
	}

	slideBackgroundToZero() {
		console.log('working')
		document.querySelector('.red').style.transform ='translateX(0%)'	
	}

	slideBackgroundToNegative() {
		console.log('leaving')
		document.querySelector('.red').style.transform = 'translateX(100%)'
	}


	openSettings() {
			this.setState({settings: true})
			document.querySelector('.settings-background').classList.add('open-settings')
			document.querySelector(`.settings-container`).style.display = 'block';
			document.querySelector(`.settings-label`).style.opacity = 0;
			setTimeout(()=>{
				document.querySelector(`.settings-container`).classList.add('show');
			}, 10)
	}

	closeSettings() {
			this.setState({settings: false})
			document.querySelector(`.settings-container`).classList.remove('show');
			document.querySelector('.settings-background').classList.remove('open-settings')
			document.querySelector(`.settings-label`).style.opacity = 1;
			setTimeout(()=>{
				document.querySelector(`.settings-container`).style.display = 'none';
			}, 500)
	}

		
	render() {
	return (
		<div id='app' className="App" >

			<div className='item box-one'>
				<CurrentDate />
			</div>
			
			<div className='box-two' onClick={this.closeSettings}>
				<Header />
			</div>

			<div id='pomo' className='item box-three' onClick={this.closeSettings} onDoubleClick={this.clickToPin}>
				<Pomodoro />
				<h2 className='widget-labels'>POMO</h2>
				<div id='pomo-pin' className='blue' />
			</div>
			<div id='weather' className='item box-four' onDoubleClick={this.clickToPin}>
				<WeatherList/>
				<h2 className='widget-labels'>WEATHER</h2>
				<div id='weather-pin' className='blue' />
			</div>
			<div id='news' className='item box-five' onClick={this.closeSettings} onDoubleClick={this.clickToPin}>
				<News />
				<h2 className='widget-labels'>NEWS</h2>
				<div id='news-pin' className='blue' />
			</div>
			<div id='settings' className=' item box-six ' onClick={this.openSettings}>
				<h2 className='settings-label widget-labels'>SETTINGS</h2>
				<div className='settings-background red trans-x' >
					<Settings />
				</div>
			</div>	
		</div>
		);
	}	
}

export default App;
